// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1r9pV","bigColWidth":"Table_bigColWidth__3XByp","biggerColWidth":"Table_biggerColWidth__5vkxT","row":"Table_row__2fyjV","col":"Table_col__3NyLM"};